module.exports = __webpack_public_path__ + "assets/delivery-address.ba533f66.svg";